// @flow strict
import styled from "styled-components";

const GuideSecondary = styled.p`
  text-align: center;
  font-size: 18px;
`;

export default GuideSecondary;
